import axios from 'axios'

class HttpException extends Error {
    public status: number
    public message: string
    constructor(status: number, message: string) {
        super(message)
        this.status = status
        this.message = message
    }
}

// have a look at this link for other GET request filters and parameters
// https://strapi.io/documentation/3.0.0-beta.x/content-api/parameters.html#filters
class NewsletterWebservice {
    public async storeNewsletter(email: string) {
        try {
            return await axios.post(process.env.VUE_APP_API_URL + 'newsletters/', {
                email,
            })
        } catch (error) {
            console.error(error)
            throw new HttpException(error.response.status, 'Could not store the newsletter email')
        }
    }
}

export const newsletterWebservice = new NewsletterWebservice()
